module.exports = __webpack_public_path__ + "media/notify.e414eb9d.wav";